var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Vehicles"},[_c('TrackerLocation',{attrs:{"vehicle":{ licensePlate: 'TM28RYY', imei: '6028016410' },"date":_vm.current_date}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }